export default {
  locale: "en",
  name: "Price Feed",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [
      { fieldName: "startDate", displayName: "Fecha inicio" },
      { fieldName: "endDate", displayName: "Fecha fin" },
    ],
  },
};
